
import state from './moduleTreatmentTypesState.js';
import mutations from './moduleTreatmentTypesMutations.js';
import actions from './moduleTreatmentTypesActions.js';
import getters from './moduleTreatmentTypesGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
